enum UtilisateurError {
	EMAIL = 'email',
	EMAIL_FORMAT = 'emailFormat',
	NOM = 'nom',
	PRENOM = 'prenom',
	CODE_POSTAL = 'codePostal',
	VILLE = 'ville',
	QUALITE = 'qualite',
	COLLECTIVITE_SLOW = 'collectiviteSlow',
	CERTIFICAT = 'certificat',
	COLLECTIVITE = 'collectivite',
	BUREAUX = 'bureaux',
	ROLE = 'role',
	CONFIRMATION = 'confirmation',
}

export default UtilisateurError;
